import React from 'react';
import Skeleton from '@material-ui/lab/Skeleton';
import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  mapSkeleton: {
    [theme.breakpoints.only('lg')]: {
      minWidth: theme.spacing(55),
    },
    [theme.breakpoints.up('xl')]: {
      minWidth: theme.spacing(60),
    },
  },
}));

const MapSectionSkeleton = () => {
  const classes = useStyles();

  return (
    <Skeleton className={classes.mapSkeleton} variant="rectangular" width="100%" height={800} />
  );
};

export { MapSectionSkeleton };
